import { useEffect } from 'react';

const useElevarEvent = ({
  location,
  productLength,
  eventType = 'dl_view_item_list',
  allImpressions = [],
  impressions = [],
  userProperties = {},
}) => {
  useEffect(() => {
    const sendElevarEvent = async () => {
      try {
        if (productLength) {
          window.ElevarDataLayer = window.ElevarDataLayer || [];
          await new Promise((resolve) => {
            window.ElevarDataLayer.push({
              event: eventType,
              user_properties: userProperties,
              ecommerce: {
                currencyCode: 'USD',
                impressions: [
                  ...allImpressions,
                ],
              },
              eventCallback: resolve,
            });
          });
        }
      } catch (error) {
        console.error('Elevar Event Error (dl_view_item_list):', error);
      }
    };

    sendElevarEvent();
  }, [location, impressions]);
};

export default useElevarEvent;
